import { render } from "./drayquote.vue?vue&type=template&id=2fc982d0"
import script from "./drayquote.vue?vue&type=script&lang=js"
export * from "./drayquote.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\e2efreight\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__